export default __webpack_public_path__ + "static/media/loginPageImage.982e6502.svg";